
import { Navigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Wrap a route to gate it by role. Usage:
 *   <Route path="alumni" element={<RoleGate roles={['admin','instructor','finance']}><AlumniPage/></RoleGate>} />
 * Falls back to a friendly "not authorized" panel rather than a blank error
 * toast — matches the pattern the backend enforces (403) so the UX tells the
 * user exactly why they can't see the page.
 */
export default function RoleGate({ roles = [], children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  const ok = roles.length === 0 || roles.includes(user.role);
  if (ok) return children;
  return (
    <div data-testid="role-gate-denied" className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="glass-card rounded-xl border border-rose-500/20 p-6 max-w-sm text-center">
        <ShieldAlert className="w-10 h-10 text-rose-400 mx-auto mb-3" />
        <h2 className="text-sm font-semibold mb-1">Not authorised</h2>
        <p className="text-[11px] text-muted-foreground">
          Your role ({user.role}) can&apos;t access this page. Please contact an administrator if you think this is an error.
        </p>
      </div>
    </div>
  );
}
